import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link } from "react-router-dom";
import { css } from 'aphrodite/no-important';
import styles from './Header.styles';
import logo from '../../assets/logo_white.png';
import {
  logoutAction,
  addFilterAction,
  getOrgSitesAction,
  getOrgs,
  getOrgUserRole,
  setCurrentSiteAction,
  setCurrentAreaAction,
  getAreasAction,
  clearFiltersAction
} from '../../reducers/actions';

import { FILTER_TYPE } from '../../constants/data';
import Dropdown from '../../components/common/dropdown/Dropdown';
import VerticalSeparator from '../../components/common/vseparator/VerticalSeparator';
import Modal from '../../components/common/modal/Modal';
import Confirmation from '../../components/common/confirmation/Confirmation';

export class Header extends Component {
  state = {
    interval: null,
    menuHidden: true,
    showFilterConfirmationModal: false,
    filterChangeText: '',
    filterToAdd: {},
    isListView: true
  };
  routeListener;
  hideAreaDropdown;
  componentWillMount() {
    this.routeListener = this.props.history.listen((location) => {
      this.hideAreaDropdown = location.pathname === '/';
      this.isListView = this.hideAreaDropdown;
    });
    this.hideAreaDropdown = this.props.history.location.pathname === '/';
    this.isListView = this.hideAreaDropdown;
  }
  componentDidMount() {
    document.body.addEventListener('click', this.handleOutsideClick);
  }
  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleOutsideClick);
    if (this.routeListener) {
      this.routeListener();
    }
  }
  handleOutsideClick=()=>{
    this.setState({menuHidden: true})
  }
  selectSite = value => {
		if(this.props.currentSite && this.props.currentSite.id !== value.id){
			this.props.setCurrentSite(value, true);
			this.props.clearFilters();
			this.props.getAreas(value.id, true, this.props.account, true);
			this.props.history.push('/');
		}
	};
  selectArea = value => {
    this.props.clearFilters();
    this.props.setCurrentArea(value, true, this.isListView);
  };
  setAreaFilter = value => {
      const filters = this.props.filters;
      const filterFound = filters.find(filter => filter.column && filter.column.toLowerCase() === 'area');
      // Same filter selected
      if (filterFound && filterFound.value === value.name) {
        return;
      }
      const areaFilter = {
        type: FILTER_TYPE.COLUMN,
        column:I18n.t('models.tag.area'),
        accessor:'areaName',
        value: value.name || '',
        sortField:'areaName'
      };
      if (filterFound) {
        this.setState({ filterToAdd: areaFilter, filterChangeText: `replace '${filterFound.value}' with '${areaFilter.value}'`, showFilterConfirmationModal: true });
      } else {
        this.props.addFilter(areaFilter);
      }
  };

  handleFilterConfirmationClose = () => {
    this.setState({ filterToAdd: {}, filterChangeText: '', showFilterConfirmationModal: false });
  }

  handleFilterConfirmationConfirm = () => {
    this.props.addFilter(this.state.filterToAdd);
    this.setState({ filterToAdd: {}, filterChangeText: '', showFilterConfirmationModal: false });
  }

  handleLogout = (e)=>{
    e.preventDefault();
    e.stopPropagation();
    this.props.logoutAction();
  }
  handleClick=()=>{
    this.setState({menuHidden: !this.state.menuHidden})
  }
  orgSet=()=> {
    return localStorage.getItem("orgId") ? true : false;
  }
  
  renderDropdown = (label, value, sites, onSelect) => {
    return (
      <Fragment>
        <div className={css(styles.field)}>
            <Dropdown
              showMenu={true}
              showIcon={true}
              label={label}
              value={value}
              options={sites}
              onSelect={onSelect}
            />
          </div>
          <VerticalSeparator />
      </Fragment>
    );
  };
  
  render() {
    let sites =
      !this.props.sites || !this.props.sites.length
        ? []
        : this.props.sites.map(site => ({ value: site, name: site.name }));
    let selectedAreaFilter = this.props.filters && this.props.filters.find(filter => filter.type === FILTER_TYPE.COLUMN && filter.accessor === 'areaName');

    let areas =
      !this.props.areas || !this.props.areas.length
        ? []
        : this.props.areas.map(area => ({ value: area, name: area.name }));
    let menuStyles = this.state.menuHidden ? [styles.navmenu, styles.isHidden] : styles.navmenu;
    return (
      <Fragment>
        <header className={css(styles.base)}>
          <div className={css(styles.logo)} title={process.env.REACT_APP_BUILD_DATE}>
            <img src={logo} className={css(styles.logoImage)} alt="logo" />
          </div>
          {
            sites && sites.length ?
            this.renderDropdown(
              I18n.t('data.site'),
              this.props.currentSite && this.props.currentSite.name,
              sites,
              this.selectSite
            ) :
            null
          }
          {
            this.hideAreaDropdown && areas && areas.length ?
            this.renderDropdown(
              I18n.t('data.area'),
              (
                selectedAreaFilter ? (selectedAreaFilter.value) :''
              ),
              areas,
              this.setAreaFilter
            ) :
            null
          }
          {
            !this.hideAreaDropdown && areas && areas.length ?
            this.renderDropdown(
              I18n.t('data.area'),
              (
                areas &&
                this.props.currentArea &&
                (
                  areas.find(
                    area => area.value.id === this.props.currentArea.id
                  ) || {}
                ).name
              ),
              areas,
              this.selectArea
            ) :
            null
          }
          <div className={css(styles.settings)}>
              <Fragment>
                <div onClick={this.handleClick}>
                  <a role="button" className={css(styles.navbarburger)} aria-label="menu" aria-expanded="false">
                  <span className={css(styles.nvbspan)} aria-hidden="true"></span>
                  <span className={css(styles.nvbspan)} aria-hidden="true"></span>
                  <span className={css(styles.nvbspan)} aria-hidden="true"></span>
                  </a>
                </div>
                <div id="nav-menu" className={css(menuStyles)}>
                  <Link to="/admin" className={css(styles.navbarItem)}>Admin</Link>
                  <a href="/v/index.html#/org" className={['superadmin','admin'].indexOf(this.props.orgUserRole) > -1 && this.orgSet() ? css(styles.navbarItem) : css(styles.displayNone) }>Admin Org</a>
                  <Link to="/" className={css(styles.navbarItem)}>Home</Link>
                  <a href="/v/index.html#/reports" className={css(styles.navbarItem)}>Reports</a>
                  <a href="/v/index.html#/selectorgs" className={this.props.orgCount > 1 ? css(styles.navbarItem) : css(styles.displayNone) }>Select Org</a>
                  <a href="https://link-labs.zendesk.com/hc/en-us/requests/new?ticket_form_id=360000334931" target="_blank" rel="noopener noreferrer" className={css(styles.navbarItem)}>Support</a>
                  <a href="/v/index.html#/workflows" className={css(styles.navbarItem)}>Workflows</a>
                  <hr className={css(styles.navbarDivider)}/>
                  <a href="/" className={css(styles.navbarItem)} onClick={this.handleLogout}>Logout</a>
                </div>
              </Fragment>
          </div>
        </header>
        <Modal
          isOpen={this.state.showFilterConfirmationModal}
          onRequestClose={this.handleFilterConfirmationClose}
          contentLabel="Confirm Area"
          title="Confirm Area">
          <Confirmation
            itemName={this.state.filterChangeText}
            confirm={this.handleFilterConfirmationConfirm}
            deny={this.handleFilterConfirmationClose}
          />
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = ({initd,  auth: { account,isAuthenticated }, tags: { filters }, sites, areas, organizations: { orgCount, orgUserRole } }) => {
  return {
    initd,
    account,
    isAuthenticated,
    orgCount,
    filters,
    orgUserRole,
    sites: sites.list,
    areas:
      sites.currentSite &&
      sites.currentSite.id in areas.map &&
      areas.map[sites.currentSite.id],
    currentSite: sites.currentSite,
    currentArea: areas.currentArea
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logoutAction() {
      dispatch(logoutAction(...arguments));
    },
    addFilter() {
      dispatch(addFilterAction(...arguments));
    },
    getOrgSites() {
      dispatch(getOrgSitesAction(...arguments))
    },
    getOrgs() {
      dispatch(getOrgs(...arguments))
    },
    getOrgUserRole() {
      dispatch(getOrgUserRole(...arguments))
    },
    setCurrentSite() {
      dispatch(setCurrentSiteAction(...arguments));
    },
    setCurrentArea() {
      dispatch(setCurrentAreaAction(...arguments));
    },
    getAreas() {
      dispatch(getAreasAction(...arguments));
    },
    clearFilters() {
      dispatch(clearFiltersAction(...arguments));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/header/Header.js